import { getLikelyEmailDomainTypo } from '../../core/utils/index.js';

function replaceTemplate(message, replacements = {}) {
  return Object.entries(replacements).reduce(
    (result, [key, value]) => result.replaceAll(`{${key}}`, String(value)),
    message
  );
}

function defaultTranslate(key, replacements = {}) {
  const defaults = {
    message: 'Did you mean {suggestedEmail}? You entered {typedEmail}.',
    useTypedEmail: 'Use {typedEmail}',
    editEmail: 'Edit email',
  };
  return replaceTemplate(defaults[key] || '', replacements);
}

/**
 * @typedef {(key: string, replacements?: Record<string, string>) => string} EmailTypoTranslate
 * @typedef {(message: string, options?: Record<string, unknown>) => boolean | Promise<boolean>} EmailTypoConfirm
 */

/**
 * @param {{
 *   email: string,
 *   translate?: EmailTypoTranslate,
 *   confirm?: EmailTypoConfirm
 * }} params
 */
export async function confirmEmailTypoIfNeeded({
  email,
  translate = defaultTranslate,
  confirm = async (_message, _options) => true,
}) {
  const typo = getLikelyEmailDomainTypo(email);
  if (!typo) return { shouldProceed: true, typo: null };

  const message = translate('message', {
    typedEmail: typo.typedEmail,
    suggestedEmail: typo.suggestedEmail,
    typedDomain: typo.typedDomain,
    suggestedDomain: typo.suggestedDomain,
  });

  const useTypedEmailLabel = translate('useTypedEmail', {
    typedEmail: typo.typedEmail,
    suggestedEmail: typo.suggestedEmail,
    typedDomain: typo.typedDomain,
    suggestedDomain: typo.suggestedDomain,
  });
  const editEmailLabel = translate('editEmail');

  const shouldProceed = await confirm(message, {
    type: 'warning',
    yesText: useTypedEmailLabel,
    noText: editEmailLabel,
    icon: 'exclamation-triangle',
    duration: 0,
  });

  return { shouldProceed, typo };
}
